export interface Multiplier {
    readonly unit: string;
    readonly value: number;
  }
  
  const MULTIPLIER_SUFFIX = 'x';
  
  export function multiply(value: string, multiplier?: Multiplier): string {
    if (!value || typeof value !== 'string') {
      return value || '';
    }
    if (multiplier === undefined) {
      return value;
    }
  
    const transformValue = (possibleValue: string) => {
      const numberValue = +(possibleValue.slice(0, -MULTIPLIER_SUFFIX.length));
  
      if (possibleValue && possibleValue.endsWith(MULTIPLIER_SUFFIX) && !isNaN(numberValue)) {
        return `${numberValue * multiplier.value}${multiplier.unit}`;
      }
  
      return possibleValue;
    };
  
    return value.includes(' ') ?
      value.split(' ').map(transformValue).join(' ') : transformValue(value);
  }